import { h, Component } from 'preact';
import PureComponent from './preact-pure-component';
import cx from 'classnames';

import { toDecimal } from '../../../../core/decimal';

export interface DataDisplayWidgetProps {
  name: string;

  externalLink?: string;

  data1: number;
  data1Label: string;

  data2: number;
  data2Label: string;

  changeAmount?: number;
  isChangePositive?: boolean; // Not sure if I should create a type or enum
  isComingSoon?: boolean;

}

export interface DataDisplayWidgetState {
  name: string;

  data1: number;
  data1Label: string;

  data2: number;
  data2Label: string;

  changeAmount?: number;
  isChangePositive?: boolean;
}

// It's called DataDisplay even though most of what is shows is comparison
// between the broker's average and the top 20 others
// because it's preferred to have this more usable
export class DataDisplayWidget extends Component<DataDisplayWidgetProps, DataDisplayWidgetState> {
  constructor(props: DataDisplayWidgetProps) {
    super(props);

    this.setState({
      name: props.name,
      data1: props.data1,
      data1Label: props.data1Label,
      data2: props.data2,
      data2Label: props.data2Label,
    });
  }

  getComingSoonBlock(props: DataDisplayWidgetProps) {
    if (props.isComingSoon) {
      return (
        <div className="hi-data-display-widget__coming-soon">
          <h4 className="hi-data-display-widget__coming-soon__h4">
            Coming soon
          </h4>
        </div>
      );
    }
  }

  getExternalLinkBlock(props: DataDisplayWidgetProps) {
    if (props.externalLink) {
      return (
        <a href={props.externalLink}
          className="hi-data-display-widget__external-link">
          Details <i className="fas fa-chevron-right"></i>
        </a>
      );
    }
  }

  getChangeAmountBlock(props: DataDisplayWidgetProps) {
    if (props.changeAmount) {
      if (props.isChangePositive) {
        return (
          <span className="hi-data-display-widget__change-amount green">
            + { props.changeAmount } <i className="fas fa-arrow-up"></i>
          </span>
        );
      } else {
        return (
          <span className="hi-data-display-widget__change-amount red">
            - { props.changeAmount } <i className="fas fa-arrow-down"></i>
          </span>
        );
      }
    }
  }

  render(props: DataDisplayWidgetProps, state: DataDisplayWidgetState) {
    return (
      <div className="hi-data-display-widget">
        { this.getComingSoonBlock(props) }
        <div className="row no-gutters">
          <div className="col-8 col-xl-9 hi-data-display-widget__name">
            { state.name }
          </div>
          <div className="col-4 col-xl-3 d-flex justify-content-end">
            { this.getExternalLinkBlock(props) }
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-6 hi-data-display-widget__data">
            <h4 className="hi-data-display-widget__data__amount">
              { toDecimal(state.data1) }
            </h4>
            <p className="hi-data-display-widget__data__label">
              { state.data1Label }
            </p>
          </div>
          <div className="col-6 hi-data-display-widget__data">
            <h4 className="hi-data-display-widget__data__amount">
              { toDecimal(state.data2) }
            </h4>
            <p className="hi-data-display-widget__data__label">
              { state.data2Label }
            </p>
          </div>
        </div>
      </div>
    ) 
  }

}